/* eslint-disable */
<template>
  <div id="modal1" class="modal">
    <div class="modal-content">
      <span class="close material-icons-outlined">close</span>

      <video class="video" id="video" controls>
        <source
          src="https://wanviewvitrinevideos.s3.eu-west-3.amazonaws.com/WANVIEW_720p.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </div>

  <section class="firstSection">
    <div class="container">
      <div class="content">
        <h1>
          La solution <strong>100% autonome</strong> pour
          <strong>animer vos écrans</strong>
        </h1>
        <h2>
          Gérez l’affichage de vos écrans en magasins et créez vos spots en
          totale autonomie
        </h2>
        <a v-on:click="scrollToForm()">
          <button>
            Je me lance<span
              class="material-icons-outlined"
              data-icon="navigate_next"
              v:click="openModal"
            >
            </span>
          </button>
        </a>
      </div>
      <div class="mouse">
        <img src="../assets/png/mouse.svg" alt="mouse" width="26" height="34" />
      </div>
    </div>
    <div class="bg-parallax">
      <img
        src="../assets/png/POLY2.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="-0.3"
        data-position-initial="360"
      />
      <img
        src="../assets/png/circleboisx2.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.5"
        data-position-initial="300"
      />
      <img
        src="../assets/png/cubebronzeblur.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.8"
        data-position-initial="150"
      />
      <img
        src="../assets/png/torebronze2x.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.2"
        data-position-initial="600"
      />
      <img
        src="../assets/png/torebronzerotated2x.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.2"
        data-position-initial="350"
      />
    </div>
    <div class="circle"></div>
    <div class="video">
      <button class="player" data-wan-trigger="modal" data-wan-data="modal1">
        <img
          src="@/assets/png/playBtn.svg"
          id="playVideobtn"
          alt="Lire la vidéo"
        />
      </button>
      <video poster="../assets/png/1.14sec.webp"></video>
    </div>
  </section>

  <section id="secondSection">
    <div class="bg-parallax">
      <img
        src="../assets/png/pyramid.webp"
        class="img-parallax"
        alt="élément spot"
        data-speed="0.2"
        data-position-initial="-100"
        style="top: -100px; left: 10%; width: 150px"
      />
      <img
        src="../assets/png/PYRAMID@2x.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.1"
        data-position-initial="-100"
        style="top: -100px; left: 80%; width: 300px"
      />
    </div>
    <div class="noFlexContainer secondSectionContainer">
      <div class="leftPart">
        <img
          laoding="lazy"
          alt="écran totem"
          src="../assets/png/totem.webp"
          width="500"
          height="500"
        />
      </div>
      <div class="rightPart">
        <article id="firstBrandPart">
          <hr class="smallOrangeBar" />
          <h2>Créez, planifiez, <strong>Communiquez !</strong></h2>
          <p>
            Créez votre spot sur-mesure
            <strong>en quelques secondes</strong> seulement avec Wanview.
            <br />
            Sélectionnez votre produit, choisissez votre animation sur-mesure et
            configurez facilement les éléments clés.
            <br />
            <b>Validez</b> : votre spot est créé ! Il est
            <strong>prêt à diffuser</strong> sur les écrans de votre choix.
            <br />
            <br />
            <b
              >Avec <strong>Wanview</strong>, c'est <strong>simple</strong>, et
              vous êtes 100% <strong>autonome</strong> !</b
            >
          </p>
          <a v-on:click="scrollToForm()">
            <button class="askForATest">
              <span class="buttonText">Demander une démo</span>
              <span class="material-icons-outlined suffig">
                chevron_right
              </span>
            </button>
          </a>
        </article>
      </div>
    </div>
  </section>

  <!-- Section "Une offre sur mesure pour tout type d"écrans"-->
  <div class="orangeSection tailoredSection">
    <div class="noFlexContainer">
      <div class="leftPart">
        <h2>
          Une offre <strong>sur-mesure</strong> <br />
          <span>pour tous types d'écrans</span> et de magasins
        </h2>
      </div>
      <div class="rightPart">
        <p>
          Quel que soit votre secteur d'activité,
          <b
            >l'<strong>affichage</strong> <strong>dynamique</strong> et la
            solution
          </b>
          <strong>Wanview</strong> pour piloter tous vos écrans
          <b>s'adaptent à vos enjeux</b>.
        </p>
      </div>
    </div>
  </div>

  <!-- Section "type d'offre par magasin"-->
  <div class="orangeSection tailoredCrossSection">
    <div class="cardContainer">
      <div class="mat-card firstSmallCard smallWidthMatCard">
        <div class="topOfSmallCard">
          <img
            src="../assets/png/test/CHARIOT.webp"
            alt="grande distribution"
          />
          <h3>Grande distribution</h3>
        </div>

        <p>
          Grande et moyenne surface, grande surface spécialisée, culture,
          bricolage, sport, habillement, bazar, bio.
          <br />
          <br />
          <b>
            <strong>Wanview</strong> vous permet de piloter vos écrans secteur
            par secteur !
          </b>
        </p>
      </div>
      <div class="mat-card smallWidthMatCard">
        <div class="topOfSmallCard">
          <img
            src="../assets/png/test/STORE_BRONZE.webp"
            alt="Boutiques et indépendants"
          />
          <h3>Point de vente</h3>
        </div>

        <p>
          Boutiques et indépendants <br />
          Santé : Médical et paramédical<br />
          Immobilier<br />
          Assurance et Banques<br />
          <br />
          <b>
            Soyez 100% <strong>autonome</strong> dans la
            <strong>création</strong> de vos <strong>spots</strong> et la
            <strong>gestion</strong> de l'affichage.
          </b>
        </p>
      </div>
      <div class="mat-card smallWidthMatCard">
        <div class="topOfSmallCard">
          <img
            src="../assets/png/test/BULLE_DISCUSSION_BRONZE.webp"
            alt="communication interne en entreprise"
          />
          <h3>Communication interne</h3>
        </div>

        <p>
          Hôtellerie & restauration <br />
          En entreprise, pour informer vos collaborateurs et visiteurs.
          <br />
          <br />
          <b>
            <strong>Créez</strong> vos <strong>spots</strong>
            <strong>facilement</strong> et maîtrisez leur
            <strong>diffusion</strong> !
          </b>
        </p>
      </div>
    </div>
    <!-- <div class="brand-container">
      <img src="../assets/png/brand-1.webp" alt="brand 1" class="brand-img" />
      <img src="../assets/png/brand-2.webp" alt="brand 2" class="brand-img" />
      <img src="../assets/png/brand-3.webp" alt="brand 3" class="brand-img" />
      <img src="../assets/png/brand-4.webp" alt="brand 4" class="brand-img" />
      <img src="../assets/png/brand-5.webp" alt="brand 5" class="brand-img" />
    </div> -->
  </div>

  <!-- Section "Wanview est la solution "clé en main" pour maitriser"-->
  <div class="specsSection">
    <div class="bg-parallax">
      <img
        src="../assets/png/torebois.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.1"
        data-position-initial="100"
        style="top: 100px; left: 65%; width: 250px; height: 250px"
      />
    </div>

    <div class="bigFlexContainer">
      <hr class="verticalHr" />
      <h2 class="centerTitle">
        Wanview est <strong>la solution "clé en main"</strong> pour maîtriser
        <br />
        l'<strong>ensemble de votre affichage</strong> digital en magasin
      </h2>
    </div>
    <div class="noFlexContainer">
      <div class="leftPart">
        <div class="expanderListContainer">
          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec1Collapse"
              data-toggle="collapse"
              data-target="#spec1"
            >
              <span class="toggleName" id="spec1Text">100% autonome</span>
              <span class="rightIcon material-icons-outlined" id="spec1Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec1">
              <div>
                <p class="expanderText">
                  Pilotez <strong>en toute indépendance</strong> la
                  communication sur les écrans de votre parc en magasin, avec
                  <strong
                    >une autonomie complète en termes de création et de
                    diffusion</strong
                  >
                  de vos spots publicitaires.
                </p>
              </div>
            </div>
          </div>

          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec2Collapse"
              data-toggle="collapse"
              data-target="#spec2"
            >
              <span class="toggleName" id="spec2Text">Facile à utiliser</span>
              <span class="rightIcon material-icons-outlined" id="spec2Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec2">
              <div>
                <p class="expanderText">
                  Wanview propose <strong>un outil simple et intuitif</strong> à
                  prendre en main et vous accompagne pas à pas pour
                  <strong
                    >créer vos spots publicitaires sans réglages superflus et
                    compliqués</strong
                  >.
                  <br />
                  <br />Prenez en main votre communication dès maintenant en
                  toute simplicité.
                </p>
              </div>
            </div>
          </div>
          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec3Collapse"
              data-toggle="collapse"
              data-target="#spec3"
            >
              <span class="toggleName" id="spec3Text">Agile et adaptable</span>
              <span class="rightIcon material-icons-outlined" id="spec3Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec3">
              <div>
                <p class="expanderText">
                  La solution Wanview répond
                  <strong
                    >aux besoins et aux évolutions de votre activité</strong
                  >
                  ainsi que dans le paramétrage de votre parc d’écrans
                  d’affichage dynamique. <br /><br />De nouveaux écrans ? Un
                  nouveau produit à promouvoir ? Un changement de prix ?
                  <strong>Gérez avec réactivité</strong> et créez rapidement
                  tous vos spots, pour les diffuser instantanément.
                </p>
              </div>
            </div>
          </div>
          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec4Collapse"
              data-toggle="collapse"
              data-target="#spec4"
            >
              <span class="toggleName" id="spec4Text">Sécurisée</span>
              <span class="rightIcon material-icons-outlined" id="spec4Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec4">
              <div>
                <p class="expanderText">
                  Grâce à des accès limités pour chaque utilisateur, définissez
                  les écrans auxquels chaque collaborateur a accès.
                  <br /><br />Wancom s’engage également pour
                  <strong>sécuriser vos données</strong> : elles sont stockées
                  en France, sur des serveurs sécurisés, conformément aux
                  réglementations RGPD.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightPart">
        <img
          src="../assets/png/1.14sec.webp"
          class="rightInlinePicture"
          alt="screenshot video Wanview"
        />
      </div>
    </div>
  </div>

  <!-- Section "Critères de diffusion"-->
  <div class="critersSection darkBlueSection">
    <div class="bg-parallax">
      <img
        src="../assets/png/circleboisx2.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.2"
        data-position-initial="-200"
        style="
          top: -200px;
          right: 25%;
          width: 200px;
          position: absolute;
          z-index: -1;
        "
      />
      <img
        src="../assets/png/POLY2@2x.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="-0.2"
        data-position-initial="1200"
        style="
          top: 0px;
          right: 25%;
          width: 200px;
          position: absolute;
          z-index: -1;
        "
      />
    </div>
    <div class="bigFlexContainer">
      <hr class="verticalHr" />
      <h2 class="centerTitle">
        <strong>Programmez vos spots</strong> grâce à
        <br />
        des <strong>critères de diffusion</strong> simples et variés !
      </h2>

      <div class="cardListContainer">
        <article class="leftCard firstCard">
          <div class="leftPart">
            <img
              src="../assets/png/wancom-days.webp"
              class="leftIcon"
              alt="jour et heure, periode"
              width="107"
              height="60"
            />
          </div>
          <div class="rightPart">
            <h4>La date</h4>
            <p>
              Choisissez vos jours de diffusion, sur des périodes données ou de
              façon ponctuelle
            </p>
          </div>
        </article>

        <article class="rightCard secondCard">
          <div class="leftPart">
            <img
              src="../assets/png/wancom-time.webp"
              class="leftIcon"
              alt="heures et jours de diffusion"
              width="107"
              height="60"
            />
          </div>
          <div class="rightPart">
            <h4>L'heure</h4>
            <p>
              Sur une plage horaire précise ou à des heures différentes selon
              les jours
            </p>
          </div>
        </article>

        <article class="leftCard thirdCard">
          <div class="leftPart">
            <img
              src="../assets/png/wancom-sun.webp"
              class="leftIcon"
              alt="Météo et température pour la diffusion"
              width="107"
              height="60"
            />
          </div>
          <div class="rightPart">
            <h4>La météo</h4>
            <p>
              Paramétrez la diffusion en fonction de la météo et/ou de la
              température locale
            </p>
          </div>
        </article>
      </div>
    </div>
  </div>

  <!-- Section "Témoignages"-->
  <div class="testimonialSection">
    <div class="leftPart"></div>
    <div class="fakeCircle">
      <img
        src="../assets/png/logoInt.webp"
        alt="logo grande distribution"
        width="110"
        height="110"
      />
    </div>
    <div class="rightPart">
      <img
        id="quotePicture"
        src="../assets/png/quotes.svg"
        alt="Avis wanview"
      />
      <p class="commentContent">
        Aujourd’hui avec Wanview, on peut véritablement se permettre d’avoir
        davantage de réactivité sur nos spots et nos écrans, on l’utilise
        spontanément parce qu’on est autonome.
      </p>
      <span class="author"> Laurent Lacon </span>
      <span class="quality"> Directeur de magasin Intermarché de Tulle </span>

      <router-link to="/testimonial">
        <button class="askForATest">
          <span class="buttonText">En savoir plus</span>
          <span class="material-icons-outlined suffig"> chevron_right </span>
        </button>
      </router-link>
    </div>
  </div>

  <!-- Section "La création de vos spots en toute simplicité"-->
  <div class="specsSection creationSection">
    <div class="bigFlexContainer">
      <hr class="verticalHr" />
      <h2 class="centerTitle">
        La <strong>création de vos spots</strong> en
        <strong>toute simplicité</strong>
      </h2>
      <p class="centerSubTitle">
        Créez avec facilité et réactivité vos campagnes de communication sur vos
        écrans dynamiques.
      </p>
    </div>
    <div class="noFlexContainer">
      <div class="rightPart">
        <img
          src="../assets/png/COL1.webp"
          class="rightInlinePicture"
          alt="écran de création"
        />
      </div>
      <div class="leftPart">
        <div class="expanderListContainer">
          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec8Collapse"
              data-toggle="collapse"
              data-target="#spec8"
            >
              <span class="toggleName" id="spec8Text"
                >Des spots sur-mesure</span
              >
              <span class="rightIcon material-icons-outlined" id="spec8Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec8">
              <div>
                <p class="expanderText">
                  Selon vos besoins et vos messages publicitaires,
                  <strong
                    >définissez les produits et les catégories pour lesquels
                    vous créez des spots</strong
                  >. <br /><br />
                  <strong>Des maquettes graphiques </strong> à votre
                  communication et votre charte
                  <strong>sont intégrées</strong> dans la solution, ainsi qu’une
                  bibliothèque d’images et vidéos évolutive.
                </p>
              </div>
            </div>
          </div>

          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec9Collapse"
              data-toggle="collapse"
              data-target="#spec9"
            >
              <span class="toggleName" id="spec9Text"
                >Une gestion facile de votre parc écran</span
              >
              <span class="rightIcon material-icons-outlined" id="spec9Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec9">
              <div>
                <p class="expanderText">
                  Définissez les écrans ou groupes d’écrans de votre parc, par
                  secteur d’activité, par rayon ou par localisation dans le
                  magasin, pour
                  <strong>adapter au mieux vos publicités à chaque écran</strong
                  >.
                </p>
              </div>
            </div>
          </div>
          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec10Collapse"
              data-toggle="collapse"
              data-target="#spec10"
            >
              <span class="toggleName" id="spec10Text"
                >Déclinaison sur tous les formats</span
              >
              <span class="rightIcon material-icons-outlined" id="spec10Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec10">
              <div>
                <p class="expanderText">
                  Une fois votre spot créé et les écrans de diffusion choisis,
                  <strong>le spot s’adapte automatiquement</strong> au format de
                  chaque écran sélectionné.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-parallax">
      <img
        src="../assets/png/pyramid.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.1"
        data-position-initial="-100"
      />
      <img
        src="../assets/png/circleboisx2.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.2"
        data-position-initial="-300"
      />
    </div>
  </div>

  <!-- Section "Mise en place rapide" -->
  <div class="setupSection lightBlueSection">
    <div class="bigFlexContainer">
      <hr class="verticalHr" />
      <h2 class="centerTitle">
        Une <strong>mise en place rapide</strong> <br />et
        <strong>un paramétrage intuitif</strong>
      </h2>
    </div>

    <div class="cardListContainer">
      <article class="leftCard firstCard">
        <img
          src="../assets/png/Groupe84.svg"
          class="leftIcon"
          alt="besoins secteur d’activité"
          width="170"
          height="50"
        />
        <h4><span class="tag">#01</span>Définissez vos besoins</h4>
        <hr />
        <p>
          Selon votre secteur d’activité, définissez les produits à mettre en
          avant dans vos spots selon une liste évolutive
        </p>
      </article>
      <article class="rightCard">
        <img
          src="../assets/png/Groupe91.svg"
          class="leftIcon"
          alt="parc écran"
          width="170"
          height="50"
        />
        <h4><span class="tag">#02</span>Définissez votre parc écran</h4>
        <hr />
        <p>
          Selon votre propre organisation : secteur, rayon, localisation dans le
          magasin
        </p>
      </article>
      <article class="leftCard firstCard">
        <img
          src="../assets/png/Groupe86.svg"
          class="leftIcon"
          alt="accès rôles équipe"
          width="170"
          height="50"
        />
        <h4>
          <span class="tag">#03</span>Définissez les accès de votre équipe
        </h4>
        <hr />
        <p>
          Configurez les rôles de chacun pour des accès limités et éviter les
          erreurs
        </p>
      </article>
      <article class="rightCard blueCard">
        <img
          src="../assets/png/Groupe87.svg"
          class="leftIcon"
          alt="Créez, planifiez, communiquez"
          width="170"
          height="50"
        />
        <h4>Créez, planifiez, communiquez</h4>
        <p>
          Vous pouvez dès maintenant créez vos spots, planifiez leur diffusion
          et les mettre à l'écran
        </p>
        <a class="askForATest2Link" v-on:click="scrollToForm()">
          <button id="askForATest4">
            <span class="buttonText">Demander une démo</span>
            <span class="material-icons-outlined suffig"> chevron_right </span>
          </button>
        </a>
      </article>
    </div>
    <img
      src="../assets/png/cubebronze.webp"
      alt="élément spot"
      class="img-parallax"
      data-speed="0.1"
      data-position-initial="-200"
      style="
        top: -200px;
        left: 18%;
        width: 200px;
        position: absolute;
        z-index: -1;
      "
    />
    <img
      src="../assets/png/torebronze.webp"
      alt="élément spot"
      class="img-parallax"
      data-speed="0.2"
      data-position-initial="-300"
      style="
        top: 50px;
        right: 18%;
        width: 250px;
        position: absolute;
        z-index: -1;
      "
    />
  </div>

  <!-- Section "Vos écran en magasin: un équipement efficace" -->
  <div class="hardwareSection darkBlueSection">
    <div class="noFlexContainer">
      <hr class="smallOrangeBar" />
      <h2 class="leftTitle">
        Vos écrans en magasin : <br /><strong>un équipement efficace</strong>
      </h2>
      <p class="rightText">
        Les écrans dédiés à l’affichage digital dynamique sont un outil
        indispensable de l’animation de votre point de vente. On fait le point
        sur votre équipement !
        <br />Captez davantage l’attention de vos clients grâce à l’affichage
        dynamique.
      </p>
    </div>
  </div>
  <div class="hardwareCrossSection">
    <div class="cardListContainer">
      <div class="leftCard">
        <p class="cardTitle">J'ai déjà des écrans</p>
        <hr />
        <p class="cardContent">
          <strong>Votre magasin est déjà équipé</strong>
        </p>
        <p class="cardContent lightBlueSection">
          La plupart des écrans sont compatibles avec la solution Wanview.
        </p>
        <p class="cardContent">
          Si votre matériel n’est pas compatible, Wancom vous propose un pack de
          compatibilité
        </p>
        <a v-on:click="scrollToForm()" class="textLink">
          Je souhaite connaître la compatibilité de mes écrans avec Wanview
        </a>
        <span class="material-icons-outlined bottomArrow"> expand_more </span>
        <a class="askForATest2Link" v-on:click="scrollToForm()">
          <button id="askForATest2">
            <span class="buttonText">Demander une démo</span>
            <span class="material-icons-outlined suffig"> chevron_right </span>
          </button>
        </a>
      </div>
      <div class="rightCard">
        <p class="cardTitle">Je souhaite équiper mon magasin</p>
        <hr />
        <p class="cardContent">
          Adopter Wanview,
          <strong
            >c’est aussi l’occasion d’équiper votre magasin pour proposer de
            l’affichage digital</strong
          >
          à vos clients
        </p>
        <p class="cardContent lightBlueSection">
          Profitez de l’expertise de Wancom et de ses partenaires - des marques
          reconnues sur le marché des écrans !
        </p>
        <p class="cardContent">
          Ecran LED, LCD, totem, mur d’image…
          <br />Arrière de caisse, rayon traditionnel, allée, salle d’attente,
          accueil…
        </p>

        <a v-on:click="scrollToForm()" class="textLink">
          Je souhaite implanter des écrans
        </a>
        <span class="material-icons-outlined bottomArrow"> expand_more </span>
        <a class="askForATest2Link" v-on:click="scrollToForm()">
          <button id="askForATest3">
            <span class="buttonText">Demander une démo</span>
            <span class="material-icons-outlined suffig"> chevron_right </span>
          </button>
        </a>
      </div>
    </div>
  </div>

  <!-- Section "le savoir faire de Wancom au service de Wanview"-->

  <div class="specsSection">
    <div class="bg-parallax">
      <img
        src="../assets/png/pyramid.webp"
        alt="élément spot"
        class="img-parallax"
        data-speed="0.2"
        data-position-initial="-1200"
        style="
          top: 50px;
          right: 15%;
          width: 150px;
          position: absolute;
          z-index: -1;
          transform: rotate(180deg);
        "
      />
    </div>
    <div class="bigFlexContainer">
      <hr class="verticalHr" />
      <h2 class="centerTitle">
        Le <strong>savoir-faire</strong> de <strong>Wancom</strong> au service
        de
        <strong>Wanview</strong>
      </h2>
      <p class="centerSubTitle">
        Wancom allie depuis 20 ans l’agilité d’une start-up pour innover
        pleinement et l’organisation d’une PME pour une réactivité optimale !
      </p>
    </div>
    <div class="noFlexContainer">
      <div class="leftPart">
        <div class="expanderListContainer">
          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec5Collapse"
              data-toggle="collapse"
              data-target="#spec5"
            >
              <span class="toggleName" id="spec5Text"
                >Une expertise globale <br />pour votre affichage digital</span
              >
              <span class="rightIcon material-icons-outlined" id="spec5Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec5">
              <div>
                <p class="expanderText">
                  Wancom propose des solutions à la grandeur de votre ambition
                  digitale : affichage indoor et outdoor (installation et
                  maintenance), création graphique, solution logicielle...
                  <br /><br />
                  Les solutions proposées s’appliquent à de nombreux secteurs
                  d’activités.
                </p>
              </div>
            </div>
          </div>

          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec6Collapse"
              data-toggle="collapse"
              data-target="#spec6"
            >
              <span class="toggleName" id="spec6Text">20 ans d’expérience</span>
              <span class="rightIcon material-icons-outlined" id="spec6Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec6">
              <div>
                <p class="expanderText">
                  Wancom fait de chacun de vos projets un défi unique et réalisé
                  sur-mesure !
                  <br />
                  <br />Innovation, écoute, rigueur et réactivité sont les clés
                  de la conception de solutions digitales adaptées à chaque
                  client, selon ses besoins. <br /><br />
                  Des réflexes acquis par Wancom qui participent depuis 20 ans à
                  son agilité compétitive.
                </p>
              </div>
            </div>
          </div>
          <div class="collapse">
            <span
              class="expanderToggle expanderGroup"
              id="spec7Collapse"
              data-toggle="collapse"
              data-target="#spec7"
            >
              <span class="toggleName" id="spec7Text"
                >Une équipe à votre service</span
              >
              <span class="rightIcon material-icons-outlined" id="spec7Icon"
                >expand_more</span
              >
            </span>
            <!--<button data-toggle="collapse" data-target="#collapse">Open me</button>-->
            <div class="collapse-content" id="spec7">
              <div>
                <p class="expanderText">
                  L’équipe Wancom, ce sont 45 collaborateurs à votre service
                  pour répondre avec réactivité, souplesse et précision à tous
                  vos besoins de communication digitale DOOH, et vous
                  accompagner au quotidien dans le pilotage et l’évolution de
                  vos solutions de communication.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightPart">
        <img
          src="../assets/png/21sec.webp"
          class="rightInlinePicture"
          alt="screenshot vidéo démo Wanview"
        />
      </div>
    </div>
  </div>

  <div id="bigFormContainer">
    <!-- <div class="bg-parallax"></div> -->
    <!-- Section Formulaire-->
    <div id="formulaire" class="formSection lightBlueSection">
      <div class="noFlexContainer darkBlueSection">
        <div class="arrow-down"></div>
        <hr class="verticalHr" />
        <h2 class="centerTitle">
          Essayer <strong>WANVIEW</strong> <b>dès maintenant !</b>
        </h2>
        <p class="centerSubTitle">
          Faites évoluer votre communication sur vos écrans d’affichages
          dynamiques en prenant contact avec notre équipe pour plus
          d’informations et une session de démonstration rapide et efficace !
        </p>
      </div>
    </div>
    <div class="formbisSection lightBlueSection">
      <div class="formContainer">
        <div class="leftPart">
          <h4>Je prends contact <br />directement</h4>
          <hr />
          <p>Wanview, une solution proposée par <strong>Wancom</strong> :</p>
          <div class="addressBlock">
            <h4>05 55 87 94 15</h4>
            <span class="email"> contact@wancom.fr </span>
            <p>
              54 av. Georges Pompidou
              <br />
              19100 Brive-la-Gaillarde
            </p>
          </div>
        </div>
        <div class="rightPart">
          <div class="formParent">
            <!-- @submit.prevent="checkForm" -->
            <form id="app" @submit.prevent="testForm">
              <h4>Notre équipe vous présente Wanview</h4>
              <hr />

              <div v-if="!loading && !send" id="topFormContainer">
                <div class="mat-form-group">
                  <div class="input-material">
                    <input
                      type="text"
                      v-model="firstName"
                      placeholder=" "
                      id="firstName"
                      required
                    />
                    <label for="firstName">Votre Prénom *</label>
                  </div>
                  <div class="input-material">
                    <input
                      type="text"
                      v-model="lastName"
                      placeholder=" "
                      id="lastName"
                      autocomplete="family-name"
                      required
                    />
                    <label for="lastName">Votre Nom *</label>
                  </div>
                </div>
                <div class="mat-form-group">
                  <div class="input-material">
                    <input
                      type="text"
                      v-model="company"
                      id="company"
                      placeholder=" "
                      required
                    />
                    <label for="company">Entreprise *</label>
                  </div>
                  <div class="input-material">
                    <input
                      type="text"
                      v-model="quality"
                      placeholder=" "
                      id="quality"
                      required
                    />
                    <label for="quality">Poste *</label>
                  </div>
                </div>
                <div class="mat-form-group">
                  <div class="input-material">
                    <input
                      type="email"
                      v-model="email"
                      placeholder=" "
                      id="email"
                      required
                    />
                    <label for="email">Email *</label>
                  </div>
                  <div class="input-material">
                    <input
                      type="tel"
                      v-model="phone"
                      placeholder=" "
                      id="phone"
                      pattern="[0-9\s]{5,14}"
                      required
                    />
                    <label for="phone">Téléphone *</label>
                  </div>
                </div>

                <div class="checkboxSoloContainer">
                  <h5 for="callBack">Je souhaite être rappelé(e)</h5>
                </div>
                <div class="checkboxSideContainer">
                  <div class="leftPart">
                    <div>
                      <input
                        type="checkbox"
                        id="Lundi"
                        name="dayLundi"
                        v-model="dayLundi"
                      />
                      <label for="Lundi">Lundi</label>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        id="Mardi"
                        name="dayMardi"
                        v-model="dayMardi"
                      />
                      <label for="Mardi">Mardi</label>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        id="Mercredi"
                        name="dayMercredi"
                        v-model="dayMercredi"
                      />
                      <label for="Mercredi">Mercredi</label>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        id="Jeudi"
                        name="dayJeudi"
                        v-model="dayJeudi"
                      />
                      <label for="Jeudi">Jeudi</label>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        id="Vendredi"
                        name="dayVendredi"
                        v-model="dayVendredi"
                      />
                      <label for="Vendredi">Vendredi</label>
                    </div>
                  </div>
                  <div class="rightPart">
                    <div>
                      <input
                        type="checkbox"
                        id="morning"
                        v-model="callBackHourMorning"
                        name="callBackHourMorning"
                      />
                      <label for="morning">Le matin (09h-12h)</label>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        id="afternoon"
                        v-model="callBackHourAfternoon"
                        name="callBackHourAfternoon"
                      />
                      <label for="afternoon">L'après-midi (14h-17h)</label>
                    </div>
                  </div>
                </div>
                <div class="checkboxSoloContainer">
                  <input
                    type="checkbox"
                    id="condition"
                    v-model="condition"
                    name="condition"
                  />
                  <label class="conditionLabel" for="condition"
                    ><span v-if="errorCond" style="color: red">
                      Merci d'accepter les conditions ci-dessous pour soumettre
                      votre demande. <br /></span
                    >En soumettant ce formulaire, j’accepte que les informations
                    saisies dans ce formulaire soient exploitées dans le cadre
                    de demande d’essai et de la relation commerciale qui peut en
                    découler. (Obligatoire)</label
                  >
                </div>

                <button id="finalAskForATest" type="submit">
                  <span class="buttonText">Je demande ma démo !</span>
                  <span class="material-icons-outlined suffig">
                    chevron_right
                  </span>
                </button>
              </div>
              <div class="loader" v-if="loading">
                <div class="logo">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class="msgSend" v-if="!loading && send">
                <span class="material-icons-outlined"> mark_email_read </span>
                <p>Message envoyé !</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playing: false,
      loading: false,
      send: false,
      errorCond: false,
      firstName: "",
      lastName: "",
      company: "",
      quality: "",
      email: "",
      phone: "",
      callBack: "",
      dayLundi: "",
      dayMardi: "",
      dayMercredi: "",
      dayJeudi: "",
      dayVendredi: "",
      condition: "",
      callBackHourMorning: "",
      callBackHourAfternoon: "",
      connexionSpeed: 0,
      //sitekey: "6LdeW24fAAAAACxi8XGU9i1upUMeS7AiSY7ne8Sz", //test
      sitekey: "6Lc29GofAAAAALbiw6qnHog7s9Uimz2ibKKrvvCj",
      vueWidgtId: 0,
    };
  },
  methods: {
    getSRC: function (str) {
      console.log("video ", str);
    },

    testForm(e) {
      console.log("testForm", e);
      // check if recaptcha is active
      if (window.grecaptcha) {
        window.grecaptcha.enterprise.ready(async () => {
          const token = await window.grecaptcha.enterprise.execute(
            this.sitekey,
            {
              action: "submit",
            }
          );
          console.log("token", token);
          if (token) {
            this.checkForm(e);
          }
          // IMPORTANT: The 'token' that results from execute is an encrypted response sent by
          // reCAPTCHA Enterprise to the end user's browser.
          // This token must be validated by creating an assessment.
          // See https://cloud.google.com/recaptcha-enterprise/docs/create-assessment
        });
      }
    },

    // render() {
    //   //render Functions using vuejs
    //   if (window.grecaptcha && window.grecaptcha.render) {
    //     this.vueWidgtId = window.grecaptcha.render("finalAskForATest", {
    //       sitekey: this.sitekey, //get your sitekey
    //       size: "invisible",
    //       callback: (results) => {
    //         console.log("results", results);
    //       },
    //     });
    //   }
    // },

    isVisible: function (el) {
      var rect = el.getBoundingClientRect();
      var viewHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight
      );
      var viewWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth
      );
      var above = rect.bottom < 0;
      var below = rect.top > viewHeight;
      var left = rect.right < 0;
      var right = rect.left > viewWidth;
      return !(above || below || left || right);
    },

    play: function () {
      document.getElementById("video").play();
      this.playing = true;
    },

    // function check captcha
    onSubmit: function (token) {
      if (token) {
        this.checkForm();
      }
    },

    checkForm: function (e) {
      console.log(e);
      e.preventDefault();
      this.condition = e.target.elements.condition.checked;
      this.callBackHourMorning = e.target.elements.callBackHourMorning.checked;
      this.callBackHourAfternoon =
        e.target.elements.callBackHourAfternoon.checked;

      let callingDays = [];

      if (this.dayLundi) {
        callingDays.push("lundi");
      }
      if (this.dayMardi) {
        callingDays.push("mardi");
      }
      if (this.dayMercredi) {
        callingDays.push("mercredi");
      }
      if (this.dayJeudi) {
        callingDays.push("jeudi");
      }
      if (this.dayVendredi) {
        callingDays.push("vendredi");
      }

      let callingTime = [];
      if (this.callBackHourMorning) {
        callingTime.push("matin");
      }
      if (this.callBackHourAfternoon) {
        callingTime.push("apres-midi");
      }

      if (this.condition) {
        // recaptcba response
        // grecaptcha.enterprise.ready(async () => {
        //   const token = await grecaptcha.enterprise.execute("site_key", {
        //     action: "LOGIN",
        //   });
        //   // IMPORTANT: The 'token' that results from execute is an encrypted response sent by
        //   // reCAPTCHA Enterprise to the end user's browser.
        //   // This token must be validated by creating an assessment.
        //   // See https://cloud.google.com/recaptcha-enterprise/docs/create-assessment
        // });
        // console.log("token", token);

        this.loading = true;
        this.errorCond = false;
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            firstName: this.firstName,
            lastName: this.lastName,
            company: this.company,
            jobTitle: this.quality,
            email: this.email,
            phone: this.phone,
            pleaseCallMe: true,
            callingDays: callingDays,
            callingTime: callingTime,
          }),
        };
        //  https://reqres.in/api/posts
        // let uri = "http://localhost:3000/api/mail";
        let uri = "https://my.wanview.fr/api/trialRequest";
        fetch(uri, requestOptions)
          .then((res) => {
            if (res.ok) {
              console.log(res);
              this.loading = false;
              this.send = true;
              this.firstName = "";
              this.lastName = "";
              this.company = "";
              this.quality = "";
              this.email = "";
              this.phone = "";
              this.condition = false;
              this.dayLundi = false;
              this.dayMardi = false;
              this.dayMercredi = false;
              this.dayJeudi = false;
              this.dayVendredi = false;
              this.callBackHourMorning = false;
              this.callBackHourAfternoon = false;
              setTimeout(() => {
                this.send = false;
              }, 1500);
            }
          })
          .catch((err) => {
            this.loading = false;
            console.error(err);
          });
      } else {
        this.errorCond = true;
      }

      //traitement du formulaire de contact avant de l'envoyer en requette http;
      //Récupération de tous les inputs;
    },

    // function scroll to element with id "formulaire"
    scrollToForm: function () {
      var elmnt = document.getElementById("formulaire");
      elmnt.scrollIntoView({ block: "start", behavior: "smooth" });
    },
  },
  mounted() {
    setTimeout(() => {
      // this.render();
      Wanframework();
      // this.updateConnexionSpeed();
    }, 1000);
    // #region Framework
    let parallax = document.querySelectorAll(".img-parallax");
    document.addEventListener("scroll", (e) => {
      e;
      for (let img of parallax) {
        var posY = parseInt(img.dataset.positionInitial);
        var speed = parseFloat(img.dataset.speed);
        var position = posY + window.scrollY * speed;
        if (this.isVisible(img)) {
          img.style.top = Math.round(position) + "px";
        }
      }
    });

    document.addEventListener("wanModal", (e) => {
      const video = document.getElementById("video");
      if (e.detail.modalOpen) {
        video.play();
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });

    function Wanframework() {
      const triggersCollapse = Array.from(
        document.querySelectorAll('[data-toggle="collapse"]')
      );

      const triggersModals = Array.from(
        document.querySelectorAll('[data-wan-trigger="modal"]')
      );
      if (triggersCollapse) {
        for (let elem of triggersCollapse) {
          elem.addEventListener("click", () => {
            const selector = elem.getAttribute("data-target");
            const targets = Array.from(document.querySelectorAll(selector));
            targets.forEach((target) => {
              target.classList.toggle("show");
              if (!target.classList.contains("show")) {
                target.style.maxHeight = "0px";
                const idBase = target.id;
                //get du texte
                const idTextNode = idBase + "Text";
                const idIconNode = idBase + "Icon";
                const idCollapse = idBase + "Collapse";
                let textNode = document.getElementById(idTextNode);
                textNode.style.fontWeight = "normal";
                let iconNode = document.getElementById(idIconNode);
                iconNode.style.transform = "rotate(0deg)";
                iconNode.style.color = "#9E1B5F";

                let collapseNode = document.getElementById(idCollapse);
                collapseNode.style.borderBottom = "dashed 2px #50699366";
              } else {
                let contents = target.childNodes;
                var hmax = 0;
                for (let content of contents) {
                  if (content.style) {
                    hmax += Number.parseInt(content.offsetHeight + 16);
                    // console.log(content.getBoundingClientRect());
                  }
                }
                target.style.maxHeight = hmax + "px";
                // Retourner l'icone de la flèche pour la tourner vers le haut
                const idBase = target.id;
                //get du texte
                const idTextNode = idBase + "Text";
                const idIconNode = idBase + "Icon";
                const idCollapse = idBase + "Collapse";
                let textNode = document.getElementById(idTextNode);
                textNode.style.fontWeight = "bold";
                let collapseNode = document.getElementById(idCollapse);
                collapseNode.style.borderBottom = "0px";
                let iconNode = document.getElementById(idIconNode);
                iconNode.style.transform = "rotate(180deg)";
                iconNode.style.color = "#0F3353";
                //reset de tous les autres expanders
                const classExpander = "expanderGroup";
                let nodes = document.getElementsByClassName(classExpander);
                for (let node of nodes) {
                  if (node.id != idCollapse) {
                    if (
                      node.style.borderBottom != null &&
                      node.style.borderBottom != "" &&
                      node.style.borderBotton != "0px"
                    ) {
                      let idTempBase = node.id.split("Collapse").join("");
                      let idTempTextNode = idTempBase + "Text";
                      let idTempIconNode = idTempBase + "Icon";
                      document.getElementById(idTempBase).style.maxHeight =
                        "0px";
                      let textTempNode =
                        document.getElementById(idTempTextNode);
                      textTempNode.style.fontWeight = "normal";
                      let iconTempNode =
                        document.getElementById(idTempIconNode);
                      iconTempNode.style.transform = "rotate(0deg)";
                      iconTempNode.style.color = "#9E1B5F";
                      node.style.borderBottom = "dashed 2px #50699366";
                    }
                  }
                }
              }
            });
          });
        }
      }
      if (triggersModals) {
        for (let btn_modal of triggersModals) {
          btn_modal.addEventListener("click", () => {
            if (btn_modal.getAttribute("data-wan-data")) {
              var selector = btn_modal.getAttribute("data-wan-data");
              var targets = document.getElementById(selector);
              targets.classList.add("show");
              document.dispatchEvent(
                new CustomEvent("wanModal", {
                  detail: {
                    modalOpen: true,
                  },
                })
              );

              var close = document.getElementsByClassName("close")[0];
              close.onclick = () => {
                targets.classList.remove("show");
                document.dispatchEvent(
                  new CustomEvent("wanModal", {
                    detail: {
                      modalOpen: false,
                    },
                  })
                );
              };
              window.onclick = (event) => {
                if (event.target == targets) {
                  targets.classList.remove("show");
                  document.dispatchEvent(
                    new CustomEvent("wanModal", {
                      detail: {
                        modalOpen: false,
                      },
                    })
                  );
                }
              };
            }
          });
        }
      }
    }
    // #endregion
  },
};
</script>

<style lang="scss">
@import "../assets/variables.scss";
@import "../styles/mainPage.scss";
.grecaptcha-badge {
  visibility: hidden;
}
</style>
